<template>
    <div>
        <v-menu
        v-model="show"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="label"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          @change="(d) => $emit('change', d)"
          @input="show = false"
        ></v-date-picker>
      </v-menu>
    </div>
</template>

<script>
    export default {
        name: 'DatePicker',
          props: ['label', 'date'],
          data: () => ({
            show: false
        }),
    }
</script>